import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./adminhome.css";
import axios from "axios";
const AdminHome = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
const [creating, setCreating] = useState(false);
const [showDevModal, setShowDevModal] = useState(false);

const [dateError, setDateError] = useState("");
  // Program form fields
  const [programName, setProgramName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [feedbackType, setFeedbackType] = useState("");

  const [message, setMessage] = useState("");
  const [showQuestionModal, setShowQuestionModal] = useState(false);
const [programs, setPrograms] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");

  const adminEmail = localStorage.getItem("email") || "Admin";


  const [questionFile, setQuestionFile] = useState(null);
const [uploadMessage, setUploadMessage] = useState("");
const [uploading, setUploading] = useState(false);

    useEffect(() => {
    axios.get("/adminprograms")
      .then((res) => setPrograms(res.data))
      .catch((err) => console.error("Error fetching programs:", err));
  }, []);


useEffect(() => {
  setDateError(""); // reset

  if (!startDate || !endDate) {
    // don't show an error until both selected
    return;
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    setDateError("Invalid date format.");
    return;
  }

  if (start > end) {
    setDateError("Start date cannot be later than End date.");
    return;
  }

  // Optional: prevent end date < today (uncomment if desired)
  // const today = new Date();
  // today.setHours(0,0,0,0);
  // if (end < today) {
  //   setDateError("End date cannot be in the past.");
  //   return;
  // }

  setDateError("");
}, [startDate, endDate]);

  const handleLogout = () => {
    localStorage.removeItem("email");
    navigate("/admin/login");
  };

const handleCreateProgram = async () => {
  // basic required fields
  if (!programName || !startDate || !endDate || !feedbackType) {
    setMessage("Please fill all fields.");
    return;
  }

  // client-side date validation (double-check)
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    setMessage("Invalid dates provided.");
    return;
  }
  if (start > end) {
    setMessage("Start date cannot be later than End date.");
    return;
  }

  setMessage("");
  setCreating(true); // disable button

  try {
    const res = await fetch("/api/admin/programs/create", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        programName,
        startDate,
        endDate,
        feedbackType,
      }),
    });

    const data = await res.json();

    if (res.ok) {
      setMessage("Program created successfully!");
      setProgramName("");
      setStartDate("");
      setEndDate("");
      setFeedbackType("");

      setTimeout(() => {
        setMessage("");
        setShowModal(false);
      }, 1500);
    } else {
      setMessage(data.error || "Failed to create program.");
    }
  } catch (err) {
    console.error(err);
    setMessage("Server error");
  } finally {
    setCreating(false);
  }
};

const todayString = (() => {
  const t = new Date();
  const yyyy = t.getFullYear();
  const mm = String(t.getMonth() + 1).padStart(2, "0");
  const dd = String(t.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
})();


const handleUploadQuestions = async () => {
  if (!selectedProgram) {
    setUploadMessage("Please select a program.");
    return;
  }

  if (!questionFile) {
    setUploadMessage("Please select an Excel file.");
    return;
  }

  setUploading(true);
  setUploadMessage("");

  const formData = new FormData();
  formData.append("file", questionFile);
  formData.append("programId", selectedProgram);

  try {
    const res = await axios.post("/api/admin/questions/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    setUploadMessage("Questions uploaded successfully!");

    setTimeout(() => {
      setShowQuestionModal(false);
      setUploadMessage("");
      setQuestionFile(null);
      setSelectedProgram("");
    }, 1500);

  } catch (err) {
    console.error(err);
    setUploadMessage("Upload failed. Please check the file format.");
  } finally {
    setUploading(false);
  }
};

  return (
    <div className="admin-home">
       
     {/* ---- NEW TOP NAVBAR ---- */}
    <nav className="admin-navbar">
      <div className="nav-left">

        <h5 className="nav-title">Admin Dashboard</h5>
      </div>

      <div className="nav-center">
        <button className="nav-btn" onClick={() => setShowModal(true)}>
          Create Program
        </button>

        <button className="nav-btn" onClick={() => navigate("/admin/uploadusers")}>
          Upload Users
        </button>

  <button
  className="nav-btn"
  // onClick={() => setShowQuestionModal(true)}//later after developing
  onClick={() => setShowDevModal(true)}
>
  Upload Questions
</button>

        <button className="nav-btn" onClick={() => navigate("/admin/dashboard")}>
          Reports
        </button>

      
      </div>

      <div className="nav-right">
        <span className="nav-welcome">Welcome, {adminEmail}</span>
        <button className="nav-logout" onClick={handleLogout}>Logout</button>
      </div>
    </nav>
     
    

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Create Program</h3>

            <label>Program Name</label>
            <input
              type="text"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
            />

            <label>Start Date</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
                 min={todayString} // optional — see below how to build todayString

            />

            <label>End Date</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={todayString} // optional — see below how to build todayString

            />
{dateError && <p className="modal-error" style={{ color: "crimson" }}>{dateError}</p>}

            <label>Feedback Type</label>
            <select
              value={feedbackType}
              onChange={(e) => setFeedbackType(e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="360">360 Degree</option>
              <option value="270">270 Degree</option>
              <option value="180">180 Degree</option>
              <option value="90">90 Degree</option>
            </select>

            {message && <p className="modal-message">{message}</p>}

            <div className="modal-actions">
              <button className="cancel-btn" onClick={() => setShowModal(false)}>
                Cancel
              </button>
             <button
  className="confirm-btn"
  onClick={handleCreateProgram}
  disabled={creating || !!dateError}
  style={{
    opacity: creating || dateError ? 0.6 : 1,
    cursor: creating || dateError ? "not-allowed" : "pointer"
  }}
>
  {creating ? "Creating..." : "Create"}
</button>
            </div>
          </div>
        </div>
      )}

{showDevModal && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h3>Feature Under Development</h3>

      <p style={{ marginTop: "10px" }}>
        Upload Questions functionality is currently under development.
        Please check back later.
      </p>

      <div className="modal-actions">
        <button
          className="confirm-btn"
          onClick={() => setShowDevModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}


{showQuestionModal && (
  <div className="modal-overlay">
    <div className="modal-box">

      <h3>Upload Questions</h3>
<label>Select Program</label>
       <select
        value={selectedProgram}
        onChange={(e) => setSelectedProgram(e.target.value)}
        className="program-select"
      >
        <option value="">-- Select Program --</option>
        {programs.map((p) => (
          <option key={p.program_id} value={p.program_id}>
            {p.program_name} ({p.feedback_type})
          </option>
        ))}
      </select>

       <label>Select Excel File</label>
      <input
        type="file"
        accept=".xlsx, .xls"
        //onChange={(e) => console.log("Selected:", e.target.files[0])}
      onChange={(e) => setQuestionFile(e.target.files[0])}
      
      />

      <div className="modal-actions">
        <button
          className="cancel-btn"
          onClick={() => setShowQuestionModal(false)}
        >
          Cancel
        </button>

        <button
          className="confirm-btn"
         onClick={handleUploadQuestions}
>
  {uploading ? "Uploading..." : "Upload"}
        </button>

        {uploadMessage && (
  <p style={{ color: uploadMessage.includes("success") ? "green" : "red" }}>
    {uploadMessage}
  </p>
)}
      </div>

    </div>
  </div>
)}

    </div>
  



);
};

export default AdminHome;
